<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
        <BuyerSellerVanguard />

      <h1 class="text-3xl mt-6">How <span class="text-red-500">V</span>A Protects its Buyers</h1>
    

    
    <p class="w-5/6 m-auto md:w-1/2">We know it can be difficult to trust a service like this, so we've put a lot of protections in place for our Buyers.</p>

        
<h1 class="text-3xl mt-6"><span class="text-red-500">V</span>A's Any-Issue Refund</h1>

<p class="w-5/6 m-auto md:w-1/2">It's important that you get <span class="text-red-500">exactly</span> what you're paying for. If there is <span class="text-red-500">ANY</span> discrepancy between what the listing says and what you receive, you will get a <span class="text-red-500">full refund</span> (including transaction costs)</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2"><span class="text-red-500">IMPORTANT!</span> to protect our Sellers, we charge a small fee ($1) for this service when you purchase an account.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2"><span class="text-red-500">EXTREMELY IMPORTANT!</span> to protect our Sellers, this policy is void if any matches are played after purchasing the account. <span class="text-red-500">Make sure everything is correct BEFORE playing a game (including unrated!)</span></p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">After your first purchase, this policy will automatically be applied to <span class="text-red-500">all future purchases for free.</span></p>

<h1 class="text-3xl mt-6">Protection against First-Time Sellers</h1>
<p class="w-5/6 m-auto md:w-1/2">We want you to feel comfortable buying from any of our Sellers, whether they have hundreds of sales or none.</p>
<p class="w-5/6 m-auto md:w-1/2 mt-2">If you purchase an account from a First-Time Seller, we hold onto your payment for 7 days <span class="text-red-500">after you confirm the account is working.</span></p>
<p class="w-5/6 m-auto md:w-1/2 mt-2">Essentially, Buyers get a FREE 7 Day Anytime-Refund Guarantee when they are a Seller's first customer, and this Guarantee does not go away after playing games.</p>

<p class="w-5/6 m-auto md:w-1/2 mt-2"><span class="text-red-500">IMPORTANT!</span> First-Time Buyers are not eligible for this, and instead <span class="text-red-500">MUST</span> pay for the Any-Issue Refund to purchase from a First-Time Seller.</p>

<h1 class="text-3xl mt-6">Rewarding Loyalty</h1>
<p class="w-5/6 m-auto md:w-1/2">As you can see, we're harsh towards new Buyers and Sellers. This is to drive home the point that there is no profit in trying to scam on this site.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2"> We believe that just like how burglars look for the least-secure house on a street, our policies will make scammers look for a less-regulated website.</p>
<p class="w-5/6 m-auto mt-2 text-red-500 md:w-1/2">Once you have a successful transaction, you'll pay less fees for every account or boosting service you buy after.</p>
<p class="w-5/6 m-auto mt-2 text-red-500 md:w-1/2">1+ Purchases: 2% less fees</p>
<p class="w-5/6 m-auto mt-2 text-red-500 md:w-1/2">3+ Purchases: 5% less fees</p>
<p class="w-5/6 m-auto mt-2 text-red-500 md:w-1/2">5+ Purchases: 8% less fees</p>
<p class="w-5/6 m-auto mt-2 text-red-500 md:w-1/2">10+ Purchases: 10% less fees</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">These discounts are automatically applied to prices when you browse for accounts.</p>

<h1 class="text-3xl mt-6"><span class="text-red-500">V</span>A's Auto-Purge Service</h1>
<p class="w-5/6 m-auto md:w-1/2">This service is our "nuclear detterent" to prevent a Seller from trying to sell the same account on both <span class="text-red-500">V</span>A and another website. </p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">All you have to do as a Buyer is click a button and <span class="text-red-500">V</span>A will automatically send an email to Riot Support with indisputable evidence of account selling, banning the account.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">The point of this Service isn't to be used, it's the fact that it CAN be used. We believe that giving Buyers this power will help attract only the most legitimate and serious Sellers to our marketplace.</p>

</div>
</template>

<script>

import BuyerSellerVanguard from './BuyerSellerVanguard'

export default {
  name: 'ProtectBuyers',
  data() {
    return {

    }
  },
  components: {BuyerSellerVanguard},
 beforeMount(){

 },    

}
</script>


// WEBPACK FOOTER //
// src/components/ProtectBuyers.vue